import { createSlice } from "@reduxjs/toolkit";
import { addAtc, deleteAtc, getAtc } from "../apiActions/atcActions";
import handleApiMessage from "../../utils/handleApiError";

export type Atc = {
  id: string;
  name: string;
  created_at: string;
};

type InitialState = {
  atc: Atc[];
  error: null | string;
  loading: {
    getAtc: boolean;
    addAtc: boolean;
    deleteAtc: boolean;
  };
};

const initialState: InitialState = {
  atc: [],
  error: null,
  loading: {
    getAtc: false,
    addAtc: false,
    deleteAtc: false,
  },
};

const atcSlice = createSlice({
  name: "category",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAtc.pending, (state: InitialState) => {
        state.loading.getAtc = true;
        state.error = null;
      })
      .addCase(getAtc.fulfilled, (state: InitialState, action) => {
        state.loading.getAtc = false;
        state.error = null;
        state.atc = action.payload;
      })
      .addCase(getAtc.rejected, (state: InitialState, action: any) => {
        state.loading.getAtc = false;
        handleApiMessage(action.payload.description, "error");
      })
      .addCase(addAtc.pending, (state: InitialState) => {
        state.loading.addAtc = true;
        state.error = null;
      })
      .addCase(addAtc.fulfilled, (state: InitialState, action) => {
        state.loading.addAtc = false;
        state.error = null;
      })
      .addCase(addAtc.rejected, (state: InitialState, action: any) => {
        state.loading.addAtc = false;
        handleApiMessage(action.payload.description, "error");
      })
      .addCase(deleteAtc.pending, (state: InitialState) => {
        state.loading.deleteAtc = true;
        state.error = null;
      })
      .addCase(deleteAtc.fulfilled, (state: InitialState, action: any) => {
        state.loading.deleteAtc = false;
        state.error = null;
      })
      .addCase(deleteAtc.rejected, (state: InitialState, action: any) => {
        state.loading.deleteAtc = false;
        handleApiMessage(action.payload.description, "error");
      });
  },
});

export default atcSlice.reducer;
